export class SkyFilterDemoModalContext {
  public appliedFilters: any[];
}
